import ApiService from '@/common/api.service'

export default {
  getListDownloadDocument () {
    return new Promise((resolve, reject) => {
      ApiService.post('/customerDocument/memberList').then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  downloadDocument (customerDocumentId) {
    return new Promise((resolve, reject) => {
      ApiService.post('/customerDocument/download', { customerDocumentId }).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getListDownloadDocumentAdmin (categoryId) {
    return new Promise((resolve, reject) => {
      ApiService.post('/customerDocument/adminList', { categoryId }).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  uploadDocument (payload) {
    return new Promise((resolve, reject) => {
      ApiService.post('/customerDocument/upload', payload).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  uploadDocumentThumbnail (payload) {
    return new Promise((resolve, reject) => {
      ApiService.post('/customerDocument/uploadThumbnail', payload).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  editDocumentInfo (payload) {
    return new Promise((resolve, reject) => {
      ApiService.post('/customerDocument/edit', payload).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  deleteDocument (customerDocumentId) {
    return new Promise((resolve, reject) => {
      ApiService.post('/customerDocument/delete', { customerDocumentId }).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  changeOrderDocument (payload) {
    return new Promise((resolve, reject) => {
      ApiService.post('/customerDocument/changeOrder', payload).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getListCategories () {
    return new Promise((resolve, reject) => {
      ApiService.post('/customerDocument/category/list').then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getListCategoriesForDocuments () {
    return new Promise((resolve, reject) => {
      ApiService.post('/customerDocument/category/PullDownList').then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  createCategory (categoryName, displayFlag) {
    return new Promise((resolve, reject) => {
      ApiService.post('/customerDocument/category/create', { categoryName, displayFlag }).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  editCategory (categoryId, categoryName, displayFlag) {
    return new Promise((resolve, reject) => {
      ApiService.post('/customerDocument/category/edit', { categoryId, categoryName, displayFlag }).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  deleteCategory (categoryId) {
    return new Promise((resolve, reject) => {
      ApiService.post('/customerDocument/category/delete', { categoryId }).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  changeOrderCategory (payload) {
    return new Promise((resolve, reject) => {
      ApiService.post('/customerDocument/category/changeOrder', payload).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getListDownloadedFile (payload, paginator) {
    return new Promise((resolve, reject) => {
      ApiService.post(`/customerDocument/download/search?page=${paginator.page - 1}&size=${paginator.size}`, payload).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  exportListDownloadedFile (payload) {
    return new Promise((resolve, reject) => {
      ApiService.post('/customerDocument/download/searchForCsv', payload).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  referDocument (customerDocumentId) {
    return new Promise((resolve, reject) => {
      ApiService.post('/customerDocument/adminRefer', { customerDocumentId }).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
}
